import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
    @Input() isOpen: boolean;
    @Input() search: any;
    @Input() template: TemplateRef<any>;
    @Input() searchButtonsTemplate: TemplateRef<any> = null;
    @Input() hasOnlySearchAndCloseButton = false;

    @Output() searchClicked = new EventEmitter<void>();
    @Output() searchAndCloseClicked = new EventEmitter<void>();
    @Output() resetClicked = new EventEmitter<void>();
    @Output() closeClicked = new EventEmitter<void>();

    constructor(public languageService: LanguageService) { }

    ngOnInit() {
        // this.isOpen = false; This line was removed to be able to let each window decide if drawer/search should be initially open or closed
    }

    handlePropertyChange(e) {
        if (e.name === "opened" && e.value === true) { 
            e.component.repaint(); // a hack to fix #2424 (dx-drawer is occasionally stuck in the closed position)
        }
    }
}
